<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">{{publicParams.name}}</p>
      <p class="update-time">{{publicParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-text margin-top-20">
        <span>公共参数说明:</span>
      </div>
      <div class="table-box">
        <tables :params-data="publicParams.request"></tables>
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: createOrderApi
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .margin-top-20 {
    margin-top: 20px;
  }
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      margin-bottom: 20px;
      font-size: 14px;
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>